export default __webpack_public_path__ + "static/media/checked-logo.49e2988c.svg";